export enum WebTagPermissionEnum {
  VIEW_SHOW_HOME = "VIEW_SHOW_HOME",
  VIEW_SHOW_WEB_ACCOUNTS_HANDLING = "VIEW_SHOW_WEB_ACCOUNTS_HANDLING",
  VIEW_SHOW_LOCAL_DATA = "VIEW_SHOW_LOCAL_DATA",
  VIEW_SHOW_BILLLING_DATA = "VIEW_SHOW_BILLLING_DATA",
  VIEW_SHOW_BANK_ACCOUNT = "VIEW_SHOW_BANK_ACCOUNT",
  VIEW_SHOW_CONCTACS_DATA = "VIEW_SHOW_CONCTACS_DATA",
  VIEW_SHOW_TPV_DATA = "VIEW_SHOW_TPV_DATA",
  VIEW_SHOW_HIRED_PRODUCTS_DATA = "VIEW_SHOW_HIRED_PRODUCTS_DATA",
  VIEW_SHOW_INVOICES = "VIEW_SHOW_INVOICES",
  VIEW_SHOW_TRANSACTIONS = "VIEW_SHOW_TRANSACTIONS",
  ACTION_LOCAL_DATA_CHANGE = "ACTION_LOCAL_DATA_CHANGE",
  ACTION_BILLING_DATA_CHANGE = "ACTION_BILLING_DATA_CHANGE",
  ACTION_ADD_TPV = "ACTION_ADD_TPV",
  ACTION_BANK_ACCOUNT_CHANGE = "ACTION_BANK_ACCOUNT_CHANGE",
  ACTION_DOWNLOAD_INVOICES = "ACTION_DOWNLOAD_INVOICES",
  ACTION_DOWNLOAD_TRANSACTIONS = "ACTION_DOWNLOAD_TRANSACTIONS",
  ACTION_CONTRACT_NEW_PRODUCTS = "ACTION_CONTRACT_NEW_PRODUCTS",
  ACTION_DOWNLOAD_HIRED_PRODUCTS_CONTRACT = "ACTION_DOWNLOAD_HIRED_PRODUCTS_CONTRACT",
  ACTION_REQUEST_MATERIAL = "ACTION_REQUEST_MATERIAL"
}
